<template>
    <app-modal-view class="lb-session-details" @close="$emit('close')">
        <template #header>
            <div class="">
                <p
                    v-t="'Sessions.detail_title'"
                    class="is-size-5 has-text-centered has-text-weight-bold"
                />
            </div>
        </template>

        <template #body>
            <div class="lb-project-modal-content">
                <div class="box">
                    <div
                        v-if="windowSize == 'mobile'"
                        class="content px-2 py-2"
                    >
                        <div
                            class="
                                has-text-centered
                                is-size-5
                                has-text-weight-bold
                            "
                        >
                            {{ session.title }}
                        </div>
                        <div
                            class="
                                has-text-centered
                                is-size-3
                                has-text-weight-bold
                                px-2
                                py-2
                            "
                        >
                            <span class="icon is-medium">
                                <i class="mdi mdi-24px mdi-key-variant"></i>
                            </span>
                            {{ session.shortCode }}
                        </div>
                        <div class="has-text-centered">
                            <figure class="image is-170x170">
                                <img
                                    v-if="session.qr"
                                    :src="session.qr"
                                    alt="Image"
                                />
                                <div v-else class="lb-no-qr" />
                            </figure>
                        </div>
                    </div>

                    <article v-else class="media">
                        <div class="media-left">
                            <figure class="image is-170x170">
                                <vue-qrcode
                                    ref="qrcode"
                                    :value="shareSessionURL"
                                />
                            </figure>
                        </div>
                        <div class="media-content">
                            <div class="content px-2 py-2">
                                <div
                                    class="
                                        has-text-centered
                                        is-size-3
                                        has-text-weight-bold
                                    "
                                >
                                    {{ session.title }}
                                </div>

                                <div
                                    class="
                                        has-text-centered
                                        is-size-6
                                        has-text-weight-bold
                                        px-2
                                        pb-0
                                        pt-4
                                    "
                                >
                                    <p>{{ $t('Sessions.open_app_code') }}</p>
                                </div>

                                <div
                                    class="
                                        has-text-centered
                                        is-size-3
                                        has-text-weight-bold
                                        px-2
                                        pb-2
                                    "
                                >
                                    <span class="icon is-medium">
                                        <i
                                            class="mdi mdi-24px mdi-key-variant"
                                        ></i>
                                    </span>
                                    {{ session.shortCode }}
                                </div>

                                <div class="field has-addons pt-5">
                                    <a
                                        :href="shareSessionURL"
                                        target="_blank"
                                        class="lb-link-with-input"
                                    >
                                        <p class="control is-expanded mb-0">
                                            <input
                                                :value="shareSessionURL"
                                                readonly
                                                class="input"
                                                type="text"
                                            />
                                        </p>
                                    </a>
                                    <p class="control">
                                        <a
                                            :class="{
                                                'has-tooltip-active':
                                                    showCopiedTooltip,
                                            }"
                                            :data-tooltip="
                                                $t(
                                                    showCopiedTooltip
                                                        ? 'Sessions.url_copied'
                                                        : 'Sessions.copy_url'
                                                )
                                            "
                                            class="button is-disabled"
                                            @click="copySessionURL"
                                        >
                                            <span class="icon is-small">
                                                <i
                                                    class="
                                                        mdi
                                                        mdi-18px
                                                        mdi-content-copy
                                                    "
                                                ></i>
                                            </span>
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </template>

        <template #footer>
            <nav class="level">
                <div class="level-left">
                    <div class="level-item">
                        <button class="button px-6">
                            <span class="icon is-medium">
                                <i class="mdi mdi-24px mdi-twitter"></i>
                            </span>
                            <span
                                v-t="'Sessions.tweet'"
                                class="has-text-grey pl-3"
                            />
                        </button>
                    </div>
                    <div class="level-item">
                        <button class="button px-6">
                            <span class="icon is-medium">
                                <i
                                    class="mdi mdi-24px mdi-google-classroom"
                                ></i>
                            </span>
                            <span
                                v-t="'Sessions.classroom'"
                                class="has-text-grey pl-3"
                            />
                        </button>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <router-link
                            v-t="'Sessions.go_to_resume'"
                            :to="{
                                name: 'session-detail',
                                params: {
                                    _id: session._id,
                                },
                            }"
                            tag="button"
                            class="button px-6 is-primary is-uppercase"
                        >
                        </router-link>
                    </div>
                </div>
            </nav>
        </template>
    </app-modal-view>
</template>

<script>
import AppModalView from '@/components/AppModalView';
import { fetchItem } from '@/services/API';
import VueQrcode from 'vue-qrcode';
export default {
    components: {
        AppModalView,
        VueQrcode,
    },
    data() {
        return {
            showCopiedTooltip: false,
        };
    },
    computed: {
        session() {
            return this.$store.state.session;
        },
        shareSessionURL() {
            return (
                process.env.VUE_APP_SHARE_SESSION_URL +
                this.session.shortCode +
                '&lang=' +
                this.$i18n.locale
            );
        },
        windowSize() {
            return this.$mq;
        },
    },
    mounted() {},
    methods: {
        copySessionURL() {
            this.$copyText(this.shareSessionURL).then((e) => {
                this.showCopiedTooltip = true;
                setTimeout(() => {
                    this.showCopiedTooltip = false;
                }, 1500);
            });
        },
    },
};
</script>

<style scoped>
.lb-session-details input,
.lb-session-details .button {
    height: 3rem;
}
footer .level {
    width: 100%;
}
.lb-link-with-input {
    width: 100%;
}
.lb-link-with-input input {
    cursor: pointer;
}
.box {
    width: auto;
}
</style>
